import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Axios from "axios";
import _, { uniqueId } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../hooks/useDataFormatterHook";
import { useDataHook } from "../../hooks/useDataHook";
import Crud from "../common/Crud";
import InputSelect from "../common/InputSelect";

const methods = [
  { value: "4", text: "None" },
  { value: "0", text: "Prefix with" },
  { value: "1", text: "Number sequentially for a game date" },
  { value: "2", text: "Number sequentially for a week" },
  { value: "3", text: "Multiply then add" },
];

const weekRanges = [
  { value: 1, text: "Sunday to Saturday" },
  { value: 2, text: "Monday to Sunday" },
  { value: 3, text: "Tuesday to Monday" },
  { value: 4, text: "Wednesday to Tuesday" },
  { value: 5, text: "Thursday to Wednesday" },
  { value: 6, text: "Friday to Thursday" },
  { value: 7, text: "Saturday to Friday" },
];

const dbsEvent = [
  { value: null, text: "none" },
  { value: 2, text: "Home Team Total" },
  { value: 3, text: "Visitor Team Total" },
];

function Events({ EventId, LeagueId, onClose, RequestEvents }) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "600px",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  //#region OPEN /CLOSE
  const [open, setOpen] = React.useState(true);
  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
    setOpen(false);
  }, [onClose]);
  //#endregion

  //#region EVENT INFO
  const path = useCallback(
    () => (EventId ? `/Events/Event_GetInfo?idEvent=${EventId}` : null),
    [EventId]
  );
  const pathDetails = useCallback(
    () => `/Events/EventDetail_GetList?idEvent=${EventId}`,
    [EventId]
  );

  const { value: Event, loadingEvent } = useDataHook({
    path,
  });

  const [event, setEvent] = useState({
    idEvent: EventId,
    eventOrder: 0,
    description: "",
    idLeague: LeagueId,
    idTargetLeague: LeagueId,
    idGameType: null,
    gameDescription: "",
    includePitchers: false,
    rotCalcMethod: "4",
    rotCalcArg1: 0,
    rotCalcArg2: 0,
    rotCalcArg3: 0,
    systemDBSEventID: null,
    idUser: Number(userInfo.userId),
  });
  const handleUpdate = (inputEvent, key, value) => { };

  const handleChange = useCallback((inputEvent, key, value) => {
    if (inputEvent) {
      inputEvent.persist();
    }
    setEvent((currentEvent) => ({
      ...currentEvent,
      [key]: inputEvent ? inputEvent?.target?.value : value,
    }));
  }, []);

  useEffect(() => {
    if (_.isEmpty(Event)) return;
    setEvent(Event);
  }, [Event]);
  //#endregion

  const [details, setDetails] = useState([]);

  //#region DROPDOWNS DATA
  const { values: leagues } = useDataFormatterHook({
    value: "idLeague",
    text: "description",
    path: `/League/League_GetAllLeagues`,
  });

  const { values: gameTypes } = useDataFormatterHook({
    value: "idGameType",
    text: "description",
    path: `/GameType/GameType_Get`,
  });
  //#endregion

  const [sport, setSport] = useState();
  const handleSport = (league) => {
    const sport = leagues.find((l) => l.value === league)?.item?.idSport ?? "";
    setSport(sport.trim());
  };

  useEffect(() => {
    const sport =
      leagues.find((l) => l.value === LeagueId)?.item?.idSport ?? "";
    setSport(sport.trim());
  }, [leagues, LeagueId]);

  const updateEvent = useCallback(
    (payload) => {
      setSaving(true);
      Axios.post(process.env.REACT_APP_API2_URL + "/Events/Event_Update", {
        ...payload,
        IdUser: Number(userInfo.userId),
      })
        .then((response) => response.data)
        .then((result) => {
          if (result >= 0) {
            RequestEvents(LeagueId);
            handleClose();
            setSaving(false);
          } else {
            setError("An error ocurred saving the event.");
          }
        });
    },
    [RequestEvents, handleClose, LeagueId, userInfo.userId]
  );

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  const insertEvent = useCallback(
    (payload) => {
      if (details.length < 2) {
        setError("Events must have at least two details.");
      } else if (details.length % 2 !== 0) {
        setError(
          "Events that generate more than one game must have an even number of details."
        );
      } else if (!payload.description) {
        setError("Description cannot be empty.");
      } else if (!payload.gameDescription) {
        setError("A Game Description is required.");
      } else if (!payload.idGameType) {
        setError("A Game Type is required.");
      } else if (!payload.idGameType) {
        setError("A Game Type is required.");
      } else {
        setSaving(true);
        Axios.post(
          process.env.REACT_APP_API2_URL + "/Events/Event_Insert",
          payload
        )
          .then((response) => response.data)
          .then((result) => {
            console.log(result);
            if (result >= 0) {
              setEvent((currentEvent) => ({
                ...currentEvent,
                idEvent: result,
              }));
              Promise.all(
                details.map((detail) =>
                  Axios.post(
                    process.env.REACT_APP_API2_URL +
                    "/Events/EventDetail_Insert",
                    {
                      ...detail,
                      Odds: !Number.isNaN(Number(detail.odds))
                        ? detail.odds
                        : 0,
                      IdEvent: result,
                      IdUser: Number(userInfo.userId),
                    }
                  ).then((response) => response.data)
                )
              )
                .then((responses) => {
                  if (responses.every((response) => response >= 0)) {
                    RequestEvents(LeagueId);
                    handleClose();
                    setSaving(false);
                  } else {
                    setError("An error ocurred saving the event.");
                    setSaving(false);
                  }
                })
                .catch((error) => {
                  setError("An error ocurred saving the event.");
                  setSaving(false);
                });
            } else {
              setError("An error ocurred saving the event.");
              setSaving(false);
            }
          })
          .catch((error) => {
            setError("An error ocurred saving the event.");
            setSaving(false);
          });
      }
    },
    [RequestEvents, details, handleClose, userInfo.userId, LeagueId]
  );

  const handleSave = () => {
    if (EventId) {
      updateEvent(event);
    } else {
      insertEvent(event);
    }
  };

  console.log("event", event);

  if (!event || loadingEvent) return <></>;
  return (
    <>
      <Dialog open={!!error} onClose={() => setError(null)} maxWidth="xs">
        <DialogTitle>Error ocurred saving event.</DialogTitle>
        <DialogContent>
          <DialogContentText>{error}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setError(null)}
            color="primary"
            variant="contained"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={open} onClose={handleClose} disableEnforceFocus>
        <DialogTitle>Event properties</DialogTitle>

        <DialogContent>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-4 p-4">
              <TextField
                required
                size="small"
                type="number"
                label="Display Order"
                value={event.eventOrder ?? 0}
                onChange={(event) => handleChange(event, "eventOrder")}
                onBlur={(event) => handleUpdate(event, "eventOrder")}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                size="small"
                type="text"
                label="Description"
                value={event.description ?? ""}
                onChange={(event) => handleChange(event, "description")}
                onBlur={(event) => handleUpdate(event, "description")}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                multiline
                minRows={4}
              />
              <InputSelect
                variant="outlined"
                size="small"
                label="Target League"
                name="name"
                data={leagues}
                placeholder="DataFormatter"
                setSelectValue={(league) => {
                  handleChange(undefined, "idTargetLeague", league);
                  handleSport(league);
                }}
                startValue={event.idTargetLeague ?? LeagueId}
              />
              <InputSelect
                variant="outlined"
                size="small"
                label="Game Type"
                name="name"
                data={gameTypes}
                placeholder="DataFormatter"
                setSelectValue={(gameType) =>
                  handleChange(undefined, "idGameType", gameType)
                }
                startValue={event.idGameType}
              />
              <TextField
                size="small"
                type="text"
                label="GameDescription"
                value={event.gameDescription ?? ""}
                onChange={(event) => handleChange(event, "gameDescription")}
                onBlur={(event) => handleUpdate(event, "gameDescription")}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                multiline
                minRows={4}
              />
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    checked={event.includePitchers ?? false}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "includePitchers",
                        event.target.checked
                      );
                      handleUpdate(
                        undefined,
                        "includePitchers",
                        event.target.checked
                      );
                    }}
                    className="w-auto"
                    size="small"
                    color="primary"
                  />
                }
                label="Copy original pitchers to new event"
              />
              <div className="relative flex flex-col gap-4 p-4 border rounded-md">
                <span className="absolute text-xs leading-3 bg-white -top-1.5">
                  Rotation Number Calculation
                </span>
                <InputSelect
                  variant="outlined"
                  size="small"
                  label="Method"
                  name="name"
                  data={methods}
                  placeholder="DataFormatter"
                  setSelectValue={(method) =>
                    handleChange(undefined, "rotCalcMethod", method)
                  }
                  startValue={event.rotCalcMethod ?? "4"}
                />
                {event.rotCalcMethod === "0" && (
                  <TextField
                    size="small"
                    type="number"
                    label="Prefix with"
                    value={event.rotCalcArg1 ?? 0}
                    onChange={(event) => handleChange(event, "rotCalcArg1")}
                    onBlur={(event) => handleUpdate(event, "rotCalcArg1")}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
                {event.rotCalcMethod === "1" && (
                  <TextField
                    size="small"
                    type="number"
                    label="Start With"
                    value={event.rotCalcArg1 ?? 0}
                    onChange={(event) => handleChange(event, "rotCalcArg1")}
                    onBlur={(event) => handleUpdate(event, "rotCalcArg1")}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
                {event.rotCalcMethod === "2" && (
                  <>
                    <TextField
                      size="small"
                      type="number"
                      label="Start With"
                      value={event.rotCalcArg1 ?? 0}
                      onChange={(event) => handleChange(event, "rotCalcArg1")}
                      onBlur={(event) => handleUpdate(event, "rotCalcArg1")}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />

                    <InputSelect
                      variant="outlined"
                      size="small"
                      label="Week"
                      name="name"
                      data={weekRanges}
                      placeholder="DataFormatter"
                      setSelectValue={(weekRange) =>
                        handleChange(undefined, "rotCalcArg2", weekRange)
                      }
                      startValue={event.rotCalcArg2}
                    />
                  </>
                )}
                {event.rotCalcMethod === "3" && (
                  <>
                    <TextField
                      size="small"
                      type="number"
                      label="Multiply by"
                      value={event.rotCalcArg1 ?? 0}
                      onChange={(event) => handleChange(event, "rotCalcArg1")}
                      onBlur={(event) => handleUpdate(event, "rotCalcArg1")}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      size="small"
                      type="number"
                      label="Then add"
                      value={event.rotCalcArg2 ?? 0}
                      onChange={(event) => handleChange(event, "rotCalcArg2")}
                      onBlur={(event) => handleUpdate(event, "rotCalcArg2")}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </>
                )}
              </div>
              <div className="relative flex flex-col gap-4 p-4 border rounded-md">
                <span className="absolute text-xs leading-3 bg-white -top-1.5">
                  Tags for 'Game Desc' & 'Team Name'
                </span>
                <div className="grid grid-cols-2 gap-4 text-center ">
                  <span>{"<VT> = Visitor Team"}</span>
                  <span>{"<VP> = Visitor Pitcher"}</span>
                  <span>{"<HT> = Home Team"}</span>
                  <span>{"<HP> = Home Pitcher"}</span>
                </div>
              </div>

              <InputSelect
                variant="outlined"
                size="small"
                label="Create as DBS Event"
                name="name"
                data={dbsEvent}
                placeholder="DataFormatter"
                setSelectValue={(dbsEvent) =>
                  handleChange(undefined, "systemDBSEventID", dbsEvent)
                }
                startValue={event.systemDBSEventID}
              />
            </div>
            <div className="flex flex-col gap-2">
              <Crud
                controlledData={details}
                fake={!EventId}
                title="Details"
                getUrl={!EventId ? null : pathDetails}
                // INSERT
                insertUrl={
                  !EventId
                    ? (_, { description, odds }) => {
                      setDetails((currentDetails) => [
                        ...currentDetails,
                        {
                          idEventDetail: uniqueId(),
                          idEvent: Number(EventId),
                          description,
                          odds: odds ? Number(odds) : 0,
                          displayOrder: currentDetails.length + 1,
                          idUser: Number(userInfo.userId),
                        },
                      ]);
                    }
                    : null
                }
                insertParams={({ userId }, { GroupName }) => ({
                  GroupName,
                  IdUser: Number(userId),
                })}
                // UPDATE
                updateUrl={
                  !EventId
                    ? (_, row) => {
                      setDetails((currentDetails) => {
                        const index = currentDetails.findIndex(
                          (detail) =>
                            detail.idEventDetail === row.idEventDetail
                        );
                        currentDetails[index] = row;
                        return currentDetails;
                      });
                    }
                    : () => "/Events/EventDetail_Update"
                }
                updateParams={(
                  { userId },
                  { idEventDetail, description, odds, displayOrder }
                ) => ({
                  IdEventDetail: Number(idEventDetail),
                  Description: description,
                  Odds: odds ? Number(odds) : 0,
                  DisplayOrder: displayOrder,
                  IdUser: Number(userId),
                })}
                // DELETE
                deleteUrl={
                  !EventId
                    ? (_, ids) => {
                      setDetails((currentDetails) =>
                        currentDetails.filter(
                          (detail) =>
                            !ids.includes(String(detail.idEventDetail))
                        )
                      );
                    }
                    : null
                }
                deleteParams={({ userId }, id) => ({
                  IdGrouping: id,
                  IdUser: Number(userId),
                })}
              >
                <TableHeaderColumn
                  visible="none"
                  hiddenOnInsert
                  autoValue={true}
                  hidden
                  isKey
                  dataField="idEventDetail"
                >
                  Id
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="description"
                  filter={{ type: "TextFilter", delay: 1000 }}
                >
                  Team Name
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="odds"
                  editable={sport === "TNT"}
                  hiddenOnInsert={sport !== "TNT"}
                  autoValue={sport !== "TNT"}
                >
                  Odds
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="idEvent"
                  autoValue
                  hidden
                  hiddenOnInsert
                >
                  IdEvent
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="idUser"
                  autoValue
                  hidden
                  hiddenOnInsert
                >
                  IdUser
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="displayOrder"
                  autoValue
                  hidden
                  hiddenOnInsert
                >
                  DisplayOrder
                </TableHeaderColumn>
              </Crud>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ height: "36px" }}
            disabled={saving}
            onClick={handleClose}
            color="secondary"
            variant="contained"
            autoFocus
          >
            Cancel
          </Button>
          <Button
            style={{ height: "36px" }}
            disabled={saving}
            onClick={handleSave}
            color="primary"
            variant="contained"
          >
            {saving ? (
              <CircularProgress
                style={{ margin: "0 auto", height: "20px", width: "20px" }}
              />
            ) : (
              "Save"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Events;
